module.exports = __webpack_public_path__ + "static/media/airplane.f2b0d9b0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/airplane.svg
// module id = 342
// module chunks = 0